<template>
  <div class="file-upload-container">
    <el-tabs v-model="activeOperate" :disabled="isUploading" @tab-change="handleOperateChange">
      <el-tab-pane v-for="type in OperateTypes" :key="type.value" :label="type.label" :name="type.value"></el-tab-pane>
    </el-tabs>
    <!-- 文件列表 -->
    <template v-if="activeOperate=='AllFile'">
      <el-table
          :data="fileListTable.data"
          height="300"
          max-height="550"
          border
          v-loading="tableLoading"
          style="width: 100%"
      >
        <el-table-column type="index" label="序号" width="60" />
        <el-table-column
            v-for="col in fileListTable.columns"
            :key="col.prop"
            :prop="col.prop"
            :label="col.label"
        />
        <el-table-column label="操作" width="100" align="center">
          <template #default="{ row }">
            <el-button
                type="danger"
                link
                size="small"
                @click="handleDeleteFile(row)"
            >
              <el-icon><Delete /></el-icon>
            </el-button>
          </template>
        </el-table-column>
        <template #empty>
          <div style="text-align: center; padding: 40px 0;">
            <el-empty description="暂无数据" />
          </div>
        </template>
      </el-table>

      <el-pagination
          v-if="fileListTable.total > 0"
          v-model:current-page="fileListTable.currentPage"
          v-model:page-size="fileListTable.pageSize"
          :page-sizes="[10, 20, 50]"
          :total="fileListTable.total"
          layout="total, prev, pager, next, jumper"
          @current-change="fileListTabPageChange"
          style="margin-top: 16px; justify-content: flex-start"
      />
    </template>
    <!-- 文件上传 类型切换标签页 -->
    <template v-if="activeOperate=='upFile'">
      <el-upload
          v-model:file-list="fileLists[activeType]"
          drag :limit="1" :auto-upload="false" :show-file-list="false" :on-change="handleFileChange"
          :on-exceed="handleExceed" :on-remove="handleRemove" :disabled="isUploading">
        <el-icon class="el-icon--upload">
          <upload-filled/>
        </el-icon>
        <div class="el-upload__text">
          拖拽文件到此处或 <em>点击上传</em>
        </div>
        <template #tip>
          <!--支持多选，最多同时上传20个文件-->
          <div class="el-upload__tip">
            暂不支持多选，一次只能上传一个文件
          </div>
        </template>
      </el-upload>

      <!-- 文件列表展示 -->
      <div class="file-list" v-if="fileLists[activeType].length">
        <div v-for="(file, index) in fileLists[activeType]" :key="file.uid" class="file-item">
          <div class="file-info">
            <el-icon>
              <document/>
            </el-icon>
            <span class="file-name">{{ file.name }}</span>
            <span class="file-size">({{ formatFileSize(file.size!) }})</span>
          </div>
          <el-button type="danger" :icon="Delete" circle size="small" @click="handleRemove(index)"
                     :disabled="isUploading"/>
        </div>
      </div>
      <!--      </el-tab-pane>-->
      <!--    </el-tabs>-->
    </template>

    <!-- 底部上传按钮 -->
    <div class="upload-footer">
      <el-button @click="emit('onClose')" :disabled="isUploading">关闭</el-button>
      <el-button type="primary" :loading="isUploading" @click="handleUpload" :disabled="!hasFiles"  v-if="activeOperate=='upFile'">
        {{ isUploading ? '上传中...' : '开始上传' }}
      </el-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {ref, reactive, computed, onMounted} from 'vue';
import {ElMessage, ElMessageBox, ElNotification, UploadFile} from 'element-plus';
import {UploadFilled, Document, Delete} from '@element-plus/icons-vue';
import {getDocumentList, upLoadKnowledgeBaseFile,deleteDocument} from "@/AIApi";
const emit = defineEmits(['onClose']);
// 上传类型定义
interface UploadType {
  label: string;
  value: string;
  disabled?: boolean;
}
const OperateTypes: UploadType[] = [
  {label: '文件列表', value: 'AllFile'},
  {label: '上传文件', value: 'upFile'}
];
const activeOperate=ref<string>('AllFile');

// 处理标签页切换 操作切换
const handleOperateChange = () => {
  fileListTable.value.currentPage = 1
  if(activeOperate.value=='AllFile')getTableData()
};


// region 文件列表展示

// 表格设置项
const tableLoading = ref(false)
const fileListTable = ref({
  total: 0,
  layout: "total, prev, pager, next, jumper",
  currentPage: 1,
  pageSize: 10,
  // 接口返回数据
  data: [],
  // 表头数据
  columns: [
    {label:'文件名称',prop:'fileName'},
    {label:'上传时间',prop:'uploadTime'},
  ],
  // 操作列
  actions: [
    {label:'操作', type:'delete'}
  ]
})

// 表格分页
function fileListTabPageChange(val: number) {
  console.log("选择当前页码", val)
  fileListTable.value.currentPage = val
  getTableData()
}
const getTableData=async ()=>{
  let parames={
    pageNum:fileListTable.value.currentPage,
    pageSize:fileListTable.value.pageSize
  }
  fileListTable.value.data =[]
  const [err, res] = await awaitTo(getDocumentList(parames))
  console.log("res", res)
  if (res.code == 1) {
    fileListTable.value.total = res.data.total
    fileListTable.value.data = res.data.records
  }
}

// 删除文件
const handleDeleteFile = async (row: any) => {
  try {
    await ElMessageBox.confirm('确定要删除该文件吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })

    const [err, res] = await awaitTo(deleteDocument(row.fileId,{}))
    if (res.code === 1) {
      ElMessage.success('删除成功')
      // 先本地移除，提升即时反馈
      removeLocalFile(row.fileId)
      // 增加延迟时间到 2 秒，给后端更多处理时间
      setTimeout(async () => {
        await getTableData()
      }, 2000)
    }
  } catch {
    // 用户取消删除
  }
}
// 本地移除文件（乐观更新）
const removeLocalFile = (fileId: string) => {
  const index = fileListTable.value.data.findIndex((item: any) => item.fileId === fileId)
  if (index !== -1) {
    fileListTable.value.data.splice(index, 1)
    fileListTable.value.total--
  }
}
// endregion

// region 上传文件
// 组件逻辑
const uploadTypes: UploadType[] = [
  {label: '矿山类型', value: 'mine'},
  {label: '水库类型', value: 'reservoir',disabled:true},
  {label: '铁路类型', value: 'railway',disabled:true},
  {label: '其他类型', value: 'other',disabled:true}
];

const activeType = ref<string>(uploadTypes[0].value);
const isUploading = ref<boolean>(false);

// 存储每种类型的文件列表
const fileLists = reactive<Record<string, UploadFile[]>>(
    uploadTypes.reduce((acc, type) => {
      acc[type.value] = [];
      return acc;
    }, {} as Record<string, UploadFile[]>)
);

// 检查当前类型是否有文件
const hasFiles = computed(() => {
  return fileLists[activeType.value].length > 0;
});

// 处理文件变化
const handleFileChange = (file: any) => {
  // console.log("file==change",file)
  const extension = file.name.split('.').pop().toLowerCase();
  if(extension === 'xls' || extension === 'xlsx'){
    ElMessageBox.confirm(
        '是否将Excel的首行数据，作为表头和每行数据进行拼装。例：首行两列分别为「姓名」「年龄」，第二行两列分别为「张三」「18」，那么开启此功能后，此Excel的切分为：“姓名：张三；年龄：18”。如果无表头，请选择否。',
        '温馨提示',
        {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'primary',
        }
    )
        .then(() => {
          file.enableHeaders=1
          return true;
        })
        .catch(() => {
          file.enableHeaders=0
          return true;
        })
  }else{
    return true;
  }
  // if (fileLists[activeType.value].length >= 1) {
  //   ElMessage.warning('一次只能上传1个文件');
  //   return false;
  // }
  // return true;
};

// 处理文件超出限制
const handleExceed = () => {
  ElMessage.warning('一次只能上传1个文件');
};

// 处理文件删除
const handleRemove = (index: number) => {
  fileLists[activeType.value].splice(index, 1);
};

// 处理标签页切换
const handleTabChange = () => {
  // 清空当前类型的文件列表
  fileLists[activeType.value] = [];
};

// 处理上传
const handleUpload = async () => {
  if (!hasFiles.value) {
    ElMessage.warning('请选择要上传的文件');
    return;
  }

  isUploading.value = true;

  try {
    const files = fileLists[activeType.value];
    const formData = new FormData();

    // 添加类型参数
    formData.append('type', activeType.value);

    // 添加所有文件到FormData
    files.forEach((file) => {
      // 注意：element-plus的UploadFile中，原始文件在raw属性中
      if (file.raw) {
        formData.append('file', file.raw);
        formData.append('enableHeaders', file.enableHeaders?1:0);
      }
    });

    // 调用上传接口
    const response = await upLoadKnowledgeBaseFile(formData)
    console.log("response",response)
    // 处理响应
    if (response.code === 1) {
      ElNotification.success({
        title: '上传成功',
        message: `成功上传${files.length}个文件`,
        duration: 3000
      });

      // 清空当前文件列表
      fileLists[activeType.value] = [];
    } else {
      ElNotification.error({
        title: '上传失败',
        message: response.msg || '上传失败',
        duration: 3000
      });
    }
  } catch (error: any) {
    ElNotification.error({
      title: '上传失败',
      message: error.message || '文件上传过程中发生错误',
      duration: 3000
    });
  } finally {
    isUploading.value = false;
  }
};

// 格式化文件大小
const formatFileSize = (size: number): string => {
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
  if (size < 1024 * 1024 * 1024) return `${(size / (1024 * 1024)).toFixed(2)} MB`;
  return `${(size / (1024 * 1024 * 1024)).toFixed(2)} GB`;
};
// endregion

// 初始化
onMounted(() => {
  handleOperateChange()
})
</script>

<style lang="scss" scoped>
.file-upload-container {
  margin: 0 auto;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.file-list {
  margin-top: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #f5f5f5;
}

.file-item:last-child {
  border-bottom: none;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
  margin-right: 10px;
}

.file-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-size {
  color: #909399;
  font-size: 12px;
}

.upload-footer {
  display: flex;
  justify-content: right;
  margin-top: 20px;
  padding-top: 20px;
}
</style>
